import { render, staticRenderFns } from "./CompensationDetails.vue?vue&type=template&id=1bc17d38&"
import script from "./CompensationDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompensationDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports